export const PATTERN_NOTES_LABEL = 'Notes';
